export const apiURL = process.env.REACT_APP_API_URL;
export const scriptURL = process.env.REACT_APP_SCRIPT_URL;
export const stripeKey: string = process.env.REACT_APP_STRIPE_KEY;
export const versionName = '3.0.1';
export const RealmAPPID = process.env.REACT_APP_REALMAPP_ID;
export const INTERCOM_APP_ID = process.env.REACT_APP_INTERCOM_APP_ID;
export const GOOGLE_TAG_MANAGER_ID =
  process.env.REACT_APP_GOOGLE_TAG_MANAGER_ID;
export const isMaintenanceMode =
  process.env.REACT_APP_IS_MAINTENANCE_MODE == 'true';
export const isMaintenanceAllowedIPs =
  process.env.REACT_APP_IS_MAINTENANCE_ALLOWED_IPS.split(',') ?? [];
export const ApiStatusUrl = process.env.REACT_APP_STATUS_URL;
export const GoogleMapKey = process.env.REACT_APP_GOOGLE_MAP_KEY;
export const agentsApiUrl = process.env.REACT_APP_AGENTS_API_URL;
export const mcpServerUrl = process.env.REACT_APP_MCP_SERVER_URL;
